module.exports = __webpack_public_path__ + "img/empty_data.71662e70.png";